import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "#FF4785";

function IconStorybook({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="#fff" d="m1.835 14.743-.5-13.206a.807.807 0 0 1 .76-.833L13.426.002a.809.809 0 0 1 .862.803v14.39a.808.808 0 0 1-.848.804L2.61 15.517a.808.808 0 0 1-.774-.774z"/>
            <path fill={fill} d="m1.835 14.743-.5-13.206a.807.807 0 0 1 .76-.833L13.426.002a.809.809 0 0 1 .862.803v14.39a.808.808 0 0 1-.848.804L2.61 15.517a.808.808 0 0 1-.774-.774z"/>
            <path fill="#fff" d="M10.9 1.967 10.977.12l1.556-.12.067 1.902a.12.12 0 0 1-.117.124.122.122 0 0 1-.079-.025l-.6-.469-.71.534a.122.122 0 0 1-.17-.023.12.12 0 0 1-.024-.077zM8.91 6.03c0 .313 2.126.163 2.412-.057 0-2.132-1.154-3.251-3.266-3.251-2.113 0-3.296 1.137-3.296 2.843 0 2.971 4.045 3.028 4.045 4.649 0 .455-.225.725-.72.725-.644 0-.898-.326-.868-1.435 0-.24-2.457-.316-2.532 0-.191 2.687 1.498 3.462 3.43 3.462 1.873 0 3.341-.99 3.341-2.78 0-3.185-4.105-3.1-4.105-4.678 0-.64.48-.725.764-.725.3 0 .84.052.794 1.247z"/>
        </svg>

    );
}

export default IconStorybook;
